import { alpha, OutlinedInput, styled } from '@mui/material'
import { TWO_FACTOR_CODE_LENGTH } from './TwoFactorCodeField.utils'

export const CodeFieldset = styled('fieldset')({
  minWidth: 0,
  margin: 0,
  padding: 0,
  border: 0,
})

// Read by screen readers only, the screen around the field tells what it's for
export const HiddenLegend = styled('legend')({
  position: 'absolute',
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
})

export const DigitBoxes = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${TWO_FACTOR_CODE_LENGTH}, minmax(0, 1fr))`,
  gap: theme.spacing(1),
}))

export const DigitBox = styled(OutlinedInput)(({ theme }) => ({
  height: 60,
  fontSize: 24,
  fontWeight: 600,
  '& input': {
    height: '100%',
    padding: 0,
    textAlign: 'center',
  },
  '&.Mui-focused': {
    backgroundColor: theme.palette.background.paper,
    boxShadow: `0 0 0 4px ${alpha(theme.palette.primary.main, 0.12)}`,
  },
}))
